"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Audio_1 = __importDefault(require("./Audio"));

var Award_1 = __importDefault(require("./Award"));

var Base_1 = __importDefault(require("./Base"));

var Education_1 = __importDefault(require("./Education"));

var Employer_1 = __importDefault(require("./Employer"));

var IFrame_1 = __importDefault(require("./IFrame"));

var IIIFManifest_1 = __importDefault(require("./IIIFManifest"));

var Image_1 = __importDefault(require("./Image"));

var Gallery_1 = __importDefault(require("./Gallery"));

var GridList_1 = __importDefault(require("./GridList"));

var Library_1 = __importDefault(require("./Library"));

var Map_1 = __importDefault(require("./Map"));

var Membership_1 = __importDefault(require("./Membership"));

var MerryGoRound_1 = __importDefault(require("./MerryGoRound"));

var Mirador_1 = __importDefault(require("./Mirador"));

var NamedAfter_1 = __importDefault(require("./NamedAfter"));

var Parallax_1 = __importDefault(require("./Parallax"));

var PDF_1 = __importDefault(require("./PDF"));

var People_1 = __importDefault(require("./People"));

var Reference_1 = __importDefault(require("./Reference"));

var SlideScroll_1 = __importDefault(require("./SlideScroll"));

var SoftwareHeritage_1 = __importDefault(require("./SoftwareHeritage"));

var Stat_1 = __importDefault(require("./Stat"));

var Tile_1 = __importDefault(require("./Tile"));

var Timeline_1 = __importDefault(require("./Timeline"));

var Video_1 = __importDefault(require("./Video"));

var Wikidata_1 = __importDefault(require("./Wikidata"));

var Wikipedia_1 = __importDefault(require("./Wikipedia"));

var YouTube_1 = __importDefault(require("./YouTube"));

exports.default = {
  AudioMoment: Audio_1.default,
  AwardMoment: Award_1.default,
  MomentBase: Base_1.default,
  EducationMoment: Education_1.default,
  EmployerMoment: Employer_1.default,
  IFrameMoment: IFrame_1.default,
  IIIFManifestMoment: IIIFManifest_1.default,
  ImageMoment: Image_1.default,
  GalleryMoment: Gallery_1.default,
  GridListMoment: GridList_1.default,
  LibraryMoment: Library_1.default,
  MapMoment: Map_1.default,
  MembershipMoment: Membership_1.default,
  MerryGoRoundMoment: MerryGoRound_1.default,
  MiradorMoment: Mirador_1.default,
  NamedAfterMoment: NamedAfter_1.default,
  ParallaxMoment: Parallax_1.default,
  PDFMoment: PDF_1.default,
  PeopleMoment: People_1.default,
  ReferenceMoment: Reference_1.default,
  SlideScrollMoment: SlideScroll_1.default,
  SoftwareHeritageMoment: SoftwareHeritage_1.default,
  StatMoment: Stat_1.default,
  TileMoment: Tile_1.default,
  TimelineMoment: Timeline_1.default,
  VideoMoment: Video_1.default,
  WikidataMoment: Wikidata_1.default,
  WikipediaMoment: Wikipedia_1.default,
  YouTubeMoment: YouTube_1.default
};